<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {}
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$router.push(from.fullPath);
        })
    }
}
</script>